<template>
  <v-img 
    v-bind="$attrs" 
    v-on="$listeners"
    eager
    @load="removePreloadingImg()"
  />
</template>
<script>
export default {
  name: 'VImage',
  created() {
    if(this.prerendering && this.$attrs['waitLoading']) {
      console.log('increase img prerender at ' + this.uid, this.$attrs)
      this.$store.commit("addPreloadingImg", this.uid);
    }
  },
  computed: {
    prerendering() {
      return this.$store.getters.prerendering;
    },
  },
  methods: {
    removePreloadingImg() {
      if(this.prerendering && this.$attrs['waitLoading']) {
        console.log('reduce img prerender at ' + this.uid, this.$attrs)
        this.$store.commit("removePreloadingImg", this.uid);
      }
    }
  }
};
</script>
